export namespace GeneralUtil {
  export function getYMDdate(date = new Date(), separator = ''): string {
    return [date.getFullYear(), date.getMonth() + 1, date.getDate()].join(
      separator
    );
  }

  export function toHash(str: string): number {
    // See https://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
    const SHIFT_BIT_COUNT = 5;

    return str.split('').reduce((hash, character): number => {
      // eslint-disable-next-line no-bitwise
      const h = (hash << SHIFT_BIT_COUNT) - hash + character.charCodeAt(0);
      // eslint-disable-next-line no-bitwise
      return h & h;
    }, 0);
  }

  export function copyObjectWithoutValues(obj: any): any {
    if (!obj) {
      return null;
    }

    const copy = {};

    for (const property in obj) {
      if (obj.hasOwnProperty(property)) {
        if (typeof obj[property] === 'object') {
          copy[property] = copyObjectWithoutValues(obj[property]);
        } else {
          copy[property] = null;
        }
      }
    }

    return copy;
  }

  function handleObjectProperties(obj: any, deep: boolean): any {
    if (Array.isArray(obj)) {
      return deep
        ? obj.map((val) => resetObjectValuesToDefault(val, deep))
        : [];
    }

    if (typeof obj === 'object') {
      return deep ? resetObjectValuesToDefault(obj, deep) : {};
    }

    return null;
  }

  export function resetObjectValuesToDefault(obj: any, deep = false): any {
    if (!obj) {
      return null;
    }

    const copy = {};

    for (const property in obj) {
      if (obj.hasOwnProperty(property)) {
        copy[property] = handleObjectProperties(obj[property], deep);
      }
    }

    return copy;
  }
}
